<template>
  <div>
    <a-dropdown v-if="loadingUserInfo" placement="bottomRight">
      <span class="ant-pro-account-avatar">
        <span>{{ currentUser.userName || '-' }}</span>
      </span>
      <template v-slot:overlay>
        <a-menu class="ant-pro-drop-down menu" :selected-keys="[]" style="top: 20px; right: -5px">
          <a-menu-item v-if="menu" key="systemInfo" @click="showSystemInfo">
            <a-icon type="bulb" />
            系统信息
          </a-menu-item>
          <a-menu-item v-if="tenantList.length > 1" key="center" @click="handleSwitchMerchant('witchMerchant')">
            <a-icon type="user" />
            切换商户
          </a-menu-item>
          <!--<a-menu-item v-if="menu" key="center" @click="handleToCenter">
            <a-icon type="user" />
            修改密码
          </a-menu-item>-->
          <!-- <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
            <a-icon type="setting" />
            < 个人设置
           </a-menu-item>-->
          <a-menu-divider v-if="menu" />
          <a-menu-item key="logout" @click="handleLogout">
            <a-icon type="logout" />
            退出登录
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <span v-else>
      <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
    </span>
    <systemInfoModal v-if="visible" :visible.sync="visible" />
    <!-- <updatePhoneModal v-if="phoneVisible" :visible.sync="phoneVisible" /> -->
    <login v-show="false" ref="comLogin"></login>
    <a-modal :centered="true" title="选择所属商户" :visible="tenantVisible" @cancel="tenantVisible = false">
      <a-list item-layout="horizontal" :data-source="tenantList">
        <a-list-item slot="renderItem" slot-scope="item" @click="handleOk(item)">
          <a-list-item-meta description="">
            <a slot="title" href="javascript:;">{{ item.tenantName }}</a>
          </a-list-item-meta>
        </a-list-item>
      </a-list>

      <template slot="footer">
        <div class="mpm_modal_buttons"></div>
      </template>
    </a-modal>
  </div>
</template>

<script>
  import login from '../../views/login/login.vue'
  import systemInfoModal from './system-info-modal'
  // import updatePhoneModal from './update-phone-modal'
  import { listPrintDevice } from 'apis/operation'
  import { getUserInfo, getSwitchTenantList, getSwitchTenant } from 'apis/user'
  export default {
    name: 'avatar-dropdown',
    components: {
      systemInfoModal,
      // updatePhoneModal,
      login,
    },
    props: {
      currentUser: {
        type: Object,
        default: () => null,
      },
      menu: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        loadingUserInfo: false,
        visible: false,
        phoneVisible: false,
        data: {},
        printVisible: false,
        tenantVisible: false,
        tenantList: [],
      }
    },
    created() {
      this.showLoadingUserInfo()
      this.initData()
      this.handleSwitchMerchant()
    },
    methods: {
      initData() {
        this.loadingUserInfo = true
        getUserInfo()
          .then((res) => {
            this.data = res
            this.$store.commit('setUserInfo', res)
          })
          .finally(() => {
            this.loadingUserInfo = false
          })
      },
      /**
       * 加载
       **/
      showLoadingUserInfo() {
        setTimeout(() => {
          this.loadingUserInfo = true
        }, 2000)
      },
      /**
       * 查看系统信息
       */
      showSystemInfo() {
        this.visible = true
      },
      handleToCenter() {
        this.phoneVisible = true
        return
        // this.$router.push({ path: '/account/center' })
      },
      handleToSettings() {
        return
        // this.$router.push({ path: '/account/settings' })
      },
      handleLogout(e) {
        this.$store.commit('setUserInfo', null)
        this.$store.commit('resetVerificationObj') // 切换账号时 销售开单-客户信息清除
        window.sessionStorage.removeItem('dictionaries')
        window.sessionStorage.removeItem('userInfo')
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('storageName')
        window.sessionStorage.removeItem('addPurchaseData')
        window.sessionStorage.removeItem('allocations')
        window.sessionStorage.removeItem('outboundPermission')
        window.sessionStorage.removeItem('ignorePermission')
        this.$router.push({ name: 'login' })
      },
      async handleSwitchMerchant(type) {
        try {
          let res = await getSwitchTenantList()
          if (!res) return
          this.tenantList = res
          type == 'witchMerchant' && (this.tenantVisible = true)
        } catch (error) {
          console.log(error)
        }
      },
      async handleOk(item) {
        try {
          let res = await getSwitchTenant({
            data: {
              accountId: item.employeeId,
              loginName: item.loginName,
              userSource: item.userSource,
            },
          })
          if (!res) return
          window.sessionStorage.setItem('tenantId', item.tenantId)
          window.sessionStorage.setItem('token', res.token)
          window.sessionStorage.setItem('userInfo', JSON.stringify(res.loginUserVO))
          // 获取订单编辑限制
          this.$store.dispatch('order/fetchOrderEditLimit')
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ant-pro-drop-down {
    .action {
      margin-right: 8px;
    }

    .ant-dropdown-menu-item {
      min-width: 160px;
    }
  }
</style>
